import { render, staticRenderFns } from "./user-tree-list.vue?vue&type=template&id=920e0320&scoped=true&"
import script from "./user-tree-list.vue?vue&type=script&lang=js&"
export * from "./user-tree-list.vue?vue&type=script&lang=js&"
import style0 from "./user-tree-list.vue?vue&type=style&index=0&id=920e0320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920e0320",
  null
  
)

export default component.exports